import { NO_VALUE_PLACEHOLDER } from "src/constants";
import { FieldProps } from "types/form";

export function getFieldTestId(fieldName: string) {
  return fieldName.replaceAll(/[._]/g, "-").toLowerCase();
}

export const reorderFields = (
  values: any,
  fromIndex: any,
  direction: any,
  move: any
) => {
  const toIndex = fromIndex + direction;
  if (toIndex >= values.length || toIndex < 0) {
    return;
  }
  move(fromIndex, toIndex);
};

export function toFieldValues(labels: Record<string, string>, required = true) {
  const fieldValues: FieldProps["values"] = [];
  if (!required) {
    fieldValues.push({ label: NO_VALUE_PLACEHOLDER, value: "" });
  }
  fieldValues.push(
    ...Object.keys(labels).map((value) => ({ label: labels[value], value }))
  );
  return fieldValues;
}
